<section class="container">
  <div class="row">
    <div class="col-lg-10 offset-lg-1">
      <div class="contentStyledText" *ngIf="cookiebotId; else textoDefectoCookies">
        <h1>{{'cookies' | transloco}}</h1>
      </div>
      <!-- <ngx-cookiebot-declaration></ngx-cookiebot-declaration> -->
      <div #ngxCookiebot></div>
      <ng-template #textoDefectoCookies>
          <neo-contentStyledText
          [text]="cookiesTxt"
        ></neo-contentStyledText>
      </ng-template>
    </div>
  </div>
  
</section>